// components/ListenSection.js
import './Listen.css';
import React, { useRef } from 'react'

const audioSamples = [
  {
    title: 'Coldplay: Viva la Vida',
    file: '/audio/Lumo-Viva-la-Vida.mp3',
  },
  {
    title: 'Carlos Gardel:Por Una Cabeza',
    file: '/audio/Lumo Por Una Cabeza lyhyt2.mp3',
  },
  {
    title: 'Daft Punk: Get Lucky',
    file: '/audio/Lumo Get Lucky pätkä2.mp3',
  },
]

export default function Listen() {
  // Ref, johon kerätään kaikki audio-elementit
  const audioRefs = useRef([])
  const handlePlay = (index) => {
    // Pause all other audios except the one that was played
    audioRefs.current.forEach((audio, i) => {
      if (audio && i !== index) {
        audio.pause()
        audio.currentTime = 0
      }
    })
  }
  return (
    <section id="listen" className="listen-section">
      <h2>Kuuntele</h2>
      {audioSamples.map((sample, idx) => (
        <div key={idx} className="audio-sample">
          <p>{sample.title}</p>
          <audio id="controlsbox"
            ref={(el) => (audioRefs.current[idx] = el)}
            controls
            onPlay={() => handlePlay(idx)}
          >
            <source src={sample.file} type="audio/mpeg" />
            Selaimesi ei tue äänitoistoa.
          </audio>
        </div>
      ))}
    </section>
  )
}
